import React from "react";
import ReactDom from "react-dom";
import videojs from 'video.js';

export default class VideoCanvas extends React.Component {

    constructor(props) {
        super(props);

        this.state = { isPaused: true, url: props.url, autoplay: props.autoplay, videoid: props.videoid };

        this.onVideoClick = this.onVideoClick.bind(this);
    }

    onVideoClick() {
        this.refs.video.paused ? this.refs.video.play() : this.refs.video.pause();
        this.setState({ isPaused: this.refs.video.paused });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.url !== prevState.url) {
            return { isPaused: true, url: nextProps.url };
        }

        return null;
    }

    render() {
        const { isPaused, url, autoplay, videoid } = this.state;
        const videoJsOptions = {
            videoid: videoid,
            autoplay: autoplay, 
            muted: autoplay,
            fluid: true,           
            controls: true,
            sources: [{ src: url, type: 'application/x-mpegURL' }]
        }
        return <div className="video-canvas">
            <VideoPlayer {...videoJsOptions}></VideoPlayer>            
        </div>
    }

}

export class VideoPlayer extends React.Component {
    componentDidMount() {
        let videoid = this.props.videoid;

        let track = function(text, type) {
            CsnInsightsEventTracker.sendEvent(CsnInsights.metaData,'video-' + videoid, text, type);
        };

        let trackProgress = function(percent) {
            track('Viewed ' + percent + '%', 'progress');
        };

        this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
            let flg25, flg50, flg75;
            let resetFlags = function() {
                flg25 = false, flg50 = false, flg75 = false;
            }

            this.on('timeupdate', function() {
                let percent = this.currentTime() * 100 / this.duration();
                if(percent > 75 && !flg75) {
                    flg75 = true;                    
                    trackProgress(75);
                } else if(percent > 50 && !flg50) {
                    flg50 = true;                    
                    trackProgress(50);
                } else if(percent > 25 && !flg25) {
                    flg25 = true;                    
                    trackProgress(25);
                }
            });
            this.on('play', function() {
                resetFlags();
                track('play', 'play');
            });
            this.on('ended', function() {
                resetFlags();
                track('End', 'End');
            });
        });
    }
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose()
        }
    }
    render() {
        return (            
                <div data-vjs-player>
                    <video ref={node => this.videoNode = node} className="video-js vjs-default-skin vjs-big-play-centered"></video>
                </div>            
        )
    }
}